module.exports = __webpack_public_path__ + "img/prestige-logo.ac9cd047.png";